// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Pressable, StyleSheet, type ViewStyle } from 'react-native';

import { Text, View } from '@/components/Themed';

type AuthStatusCardProps = {
  title: string;
  status?: string | null;
  error?: string | null;
  buttonLabel?: string;
  onPress?: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
  style?: ViewStyle;
  buttonTestID?: string;
};

export const AuthStatusCard = ({ title, status, error, buttonLabel, onPress, disabled, children, style, buttonTestID }: AuthStatusCardProps) => {
  return (
    <View style={[styles.card, style]}>
      <Text style={styles.title}>{title}</Text>
      {children}
      {status ? <Text style={styles.status}>{status}</Text> : null}
      {error ? <Text style={styles.error}>{error}</Text> : null}
      {buttonLabel && onPress ? (
        <Pressable
          accessibilityRole="button"
          testID={buttonTestID ?? 'auth-status-card-action'}
          style={[styles.button, disabled ? styles.buttonDisabled : null]}
          onPress={onPress}
          disabled={disabled}>
          <Text style={styles.buttonText}>{buttonLabel}</Text>
        </Pressable>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#07200D',
    borderRadius: 16,
    padding: 18,
    gap: 12,
    borderWidth: 1,
    borderColor: '#1A3A20',
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: '#F5F5DC',
  },
  status: {
    color: '#a7f3d0',
  },
  error: {
    color: '#ff7b7b',
  },
  button: {
    marginTop: 8,
    backgroundColor: '#A1D493',
    paddingVertical: 12,
    borderRadius: 12,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#A1D493',
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  buttonText: {
    color: '#F5F5DC',
    fontWeight: '800',
    fontSize: 16,
  },
});
